export default __webpack_public_path__ + "static/media/cover.cad98d1c.png";